import React from 'react';
import { BaseStagePlugin, useActiveOriginIndex, useIsLongImageMode } from '@/framework';
import { useEliminatePenState } from '../states/eliminate-pen-state';
import { EliminatePen } from './eliminate-pen';

export const EliminatePenPluginView: React.FC = React.memo(() => {
    const originIndex = useActiveOriginIndex();
    const isLongImageMode = useIsLongImageMode();
    const originLayer = useEliminatePenState()((state) => state.originLayer);

    // ATTENTION: 插件仅处理单画布的主图场景
    if (!originLayer || isLongImageMode) return null;

    return (
        <BaseStagePlugin enablePointerEvents originIndexOrLayerId={originIndex} name="main-layer-eliminate-pen">
            <EliminatePen originLayer={originLayer} originIndex={originIndex} />
        </BaseStagePlugin>
    );
});
